export default "__VITE_ASSET__CpO5b4JD__"